// Module
var code = `<base-button btn-context="{{btnContext}}" btn-size="{{btnSize}}" btn-type="{{btnType}}" btn-click="executeBtnClick(\$event)"> <i class="fa fa-pencil"></i> <span ng-if="!btnIconOnly">{{ 'Generic.Edit' | translate }}</span> </base-button> `;
// Exports
module.exports = code;